import { useMediaQuery } from "@mantine/hooks";

const PHONE_MQ = "(max-width: 47.99em)";
const FOUR_COL_MQ = "(min-width: 75em)";
const WIDE_DESKTOP_MQ = "(min-width: 100em)";

export function useDiscoverHeroDonutMetrics() {
  const isPhone = useMediaQuery(PHONE_MQ, false, { getInitialValueInEffect: true });
  const isFourCol = useMediaQuery(FOUR_COL_MQ, false, { getInitialValueInEffect: true });
  const isWideDesktop = useMediaQuery(WIDE_DESKTOP_MQ, false, { getInitialValueInEffect: true });

  if (isPhone) {
    return {
      size: 72,
      thickness: 13,
      labelFontSize: 12,
      legendSize: "xs" as const,
      companiesSize: "xs" as const,
      legendGap: 1,
      swatch: 8,
    };
  }

  if (isFourCol && !isWideDesktop) {
    return {
      size: 80,
      thickness: 16,
      labelFontSize: 13,
      legendSize: "xs" as const,
      companiesSize: "xs" as const,
      legendGap: 2,
      swatch: 8,
    };
  }

  if (isWideDesktop) {
    return {
      size: 120,
      thickness: 20,
      labelFontSize: 16,
      legendSize: "sm" as const,
      companiesSize: "sm" as const,
      legendGap: 4,
      swatch: 10,
    };
  }

  return {
    size: 108,
    thickness: 22,
    labelFontSize: 18,
    legendSize: "xs" as const,
    companiesSize: "xs" as const,
    legendGap: 3,
    swatch: 8,
  };
}

/** Large type only on wide desktops so 4-col MacBook / 125% zoom keeps compact headers. */
export function useDiscoverHeroIsDesktop() {
  return useMediaQuery(WIDE_DESKTOP_MQ, false, { getInitialValueInEffect: true });
}

export function useDiscoverHeroIsPhone() {
  return useMediaQuery(PHONE_MQ, false, { getInitialValueInEffect: true });
}

export type DiscoverHeroStatLayout = "row" | "column";
